import React from 'react';
import { HubMarketingNav } from '../../../components/ui/HubHeader';
import Seo from '../../../components/Seo';
import { Link } from 'react-router-dom';

const guideImage = '/assets/images/neevii-guide-sidebar-thumb-v1.png';

const SheetsGuidePage = () => {
  return (
    <>
      <Seo
        title="Neevii Sheets Setup Guide | Neevii"
        description="Visual onboarding guide for the Neevii Google Sheets sidebar, including sidebar, sheet area, and setup flow references."
      />
      <div className="min-h-screen text-foreground">
        <HubMarketingNav preset="sheets" />
        <main className="pt-10 pb-16 px-6 md:pt-12 lg:px-8">
          <div className="max-w-6xl mx-auto space-y-10">
            <section className="grid gap-6 lg:grid-cols-[1fr_1.25fr] rounded-3xl border border-border bg-card/40 p-6 lg:p-8">
              <div className="space-y-5">
                <span className="inline-flex rounded-full bg-[#065aaf] px-3 py-1 text-xs font-semibold uppercase tracking-wide text-white">
                  Neevii Smart Expenses for Google Sheets
                </span>
                <div className="space-y-3 max-w-3xl">
                  <h1 className="text-4xl md:text-5xl font-semibold leading-tight">
                    Neevii Smart Expenses
                  </h1>
                  <p className="text-lg text-muted-foreground">
                    This page turns the setup diagram into a working guide. Use the
                    overview map for the big picture, then jump through the focused
                    sections below when you want to work on a specific part of the
                    flow.
                  </p>
                </div>

                <div className="flex flex-wrap gap-3">
                  <Link
                    to="/sheets"
                    className="inline-flex items-center justify-center rounded-lg bg-[#065aaf] px-5 py-3 text-sm font-semibold uppercase tracking-wide text-white hover:bg-[#065aaf]/90"
                  >
                    Back to Sheets page
                  </Link>
                  <Link
                    to="/sheets-google-review"
                    className="inline-flex items-center justify-center rounded-lg border border-[#065aaf] px-5 py-3 text-sm font-semibold uppercase tracking-wide text-[#065aaf] hover:bg-[#065aaf]/10"
                  >
                    Google review demo
                  </Link>
                  <Link
                    to="/support-sheets"
                    className="inline-flex items-center justify-center rounded-lg border border-border px-5 py-3 text-sm font-semibold uppercase tracking-wide text-foreground hover:bg-muted/50"
                  >
                    Sidebar support
                  </Link>
                </div>
              </div>

              <aside className="overflow-hidden rounded-2xl border border-border bg-[#a1aec4] p-2">
                <img
                  src="/assets/images/neevii-sheets-main-v1.png"
                  alt="Neevii Sheets main workspace"
                  className="h-full w-full scale-[1.2] object-contain"
                />
              </aside>
            </section>

            <section className="rounded-3xl border border-[#065aaf]/30 bg-[#065aaf]/5 p-6 lg:p-8 space-y-4">
              <h2 className="text-2xl font-semibold">First-time setup (Marketplace install)</h2>
              <p className="text-sm text-muted-foreground max-w-3xl">
                Use the Extensions menu in Google Sheets. A standalone &ldquo;Neevii AI&rdquo; menu
                bar item indicates an older bound-script install, not the published add-on.
              </p>
              <ol className="list-decimal pl-6 space-y-2 text-muted-foreground max-w-3xl">
                <li>Open a Google Sheet.</li>
                <li>
                  <strong>Extensions</strong> → <strong>Neevii Smart Expenses</strong> →{' '}
                  <strong>Open/Reopen Neevii Sidebar</strong>
                </li>
                <li>
                  <strong>Continue with Google</strong>, then <strong>Create expense template</strong>
                </li>
                <li>Set <strong>Tax Jurisdiction</strong> (UK or US) in the sidebar.</li>
              </ol>
            </section>

            <section className="rounded-3xl border border-border bg-card/30 p-4 lg:p-6 space-y-4 xl:-mx-44">
              <div>
                <div>
                  <h2 className="text-2xl font-semibold">Master guide map</h2>
                  <p className="text-sm text-amber-700 dark:text-amber-400">
                    Diagrams below may still show the legacy &ldquo;Neevii AI&rdquo; menu — follow the
                    Extensions steps above for Marketplace installs.
                  </p>
                  <p className="text-sm text-muted-foreground">
                    The full onboarding layout, shown as a single reference board.
                  </p>
                </div>
              </div>
              <div className="overflow-hidden rounded-2xl border border-border bg-card/40">
                <img
                  src={guideImage}
                  alt="Neevii Sheets setup guide master map"
                  className="block h-auto w-full"
                />
              </div>
            </section>

          </div>
        </main>
      </div>
    </>
  );
};

export default SheetsGuidePage;
